import { useMutation } from '@tanstack/react-query';
import config from 'src/config';
import { InvoiceAssociationInfo, DeleteInvoiceResult } from './types';

interface GetAssociationsResponse {
  data: InvoiceAssociationInfo;
}

interface DeleteInvoiceResponse {
  data: DeleteInvoiceResult;
}

export const useGetInvoiceAssociations = () => {
  return useMutation<GetAssociationsResponse, Error, string>({
    mutationFn: async (invoiceId: string) => {
      const response = await fetch(
        `${config.apiBaseUrl}/rebates/invoices/${invoiceId}/associations`,
        {
          credentials: 'include',
        },
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to fetch invoice associations');
      }

      return response.json();
    },
  });
};

export const useDeleteRebateInvoice = () => {
  return useMutation<
    DeleteInvoiceResponse,
    Error,
    { invoiceId: string; agreementId: string; force?: boolean }
  >({
    mutationFn: async ({ invoiceId, agreementId, force = false }) => {
      const params = new URLSearchParams({
        agreementId,
        ...(force && { force: 'true' }),
      });

      const response = await fetch(
        `${
          config.apiBaseUrl
        }/rebates/invoices/${invoiceId}?${params.toString()}`,
        {
          method: 'DELETE',
          credentials: 'include',
        },
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to delete invoice');
      }

      return response.json();
    },
  });
};
